var exports = {
  "S": "AnimatedAnnotationIcon__GK2BSU",
};

module.exports = exports;
